import { render, staticRenderFns } from "./gkTestB.vue?vue&type=template&id=7a7c7053&scoped=true&"
import script from "./gkTestB.vue?vue&type=script&lang=js&"
export * from "./gkTestB.vue?vue&type=script&lang=js&"
import style0 from "./gkTestB.vue?vue&type=style&index=0&id=7a7c7053&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7c7053",
  null
  
)

export default component.exports